import { render, staticRenderFns } from "./settingVersionList.vue?vue&type=template&id=60c30cec"
import script from "./settingVersionList.vue?vue&type=script&lang=js"
export * from "./settingVersionList.vue?vue&type=script&lang=js"
import style0 from "./settingVersionList.vue?vue&type=style&index=0&id=60c30cec&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports